(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4796);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var components_Global_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6402);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5378);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .io-target {\n    position: absolute;\n    top: 0;\n    height: 60px;\n    width: 100%;\n    z-index: -1;\n  }\n  position: fixed;\n  z-index: 99;\n  bottom: 56px;\n  text-align: right;\n  right: 32px;\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    bottom: 32px;\n    right: 32px;\n  }\n  @media screen and (max-width: 599px) {\n    bottom: 32px;\n    right: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var FloatingController = function(param) {
    var isVisible = param.isVisible;
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().push;
    var handleClickScrollBtn = function() {
        if (!isVisible) (0,seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_4__/* .scrollTo */ .X5)(window, {
            top: 0,
            behavior: "smooth"
        });
        else {
            var $aboutMainBanner = document.querySelector(".main-section-container");
            if ($aboutMainBanner) {
                var scrollValue = $aboutMainBanner.getBoundingClientRect().height;
                (0,seamless_scroll_polyfill__WEBPACK_IMPORTED_MODULE_4__/* .scrollTo */ .X5)(window, {
                    top: scrollValue,
                    behavior: "smooth"
                });
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FloatingControllerContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Global_index__WEBPACK_IMPORTED_MODULE_2__/* .ScrollButton */ .xE, {
                isOpenContact: false,
                isScrolled: !isVisible,
                onClick: handleClickScrollBtn
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Global_index__WEBPACK_IMPORTED_MODULE_2__/* .ContactButton */ .AI, {
                onClick: function() {
                    return push("/contact");
                }
            })
        ]
    });
};
var FloatingControllerContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FloatingController__FloatingControllerContainer",
    componentId: "sc-9575fc0c-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (FloatingController);


/***/ }),

/***/ 5305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useDisablePinchZoom; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useDisablePinchZoom = function() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleDisablePinchZoom = function(e) {
            if (e.touches.length > 1 || e.targetTouches.length > 1) {
                e.preventDefault();
            }
        };
        var handleDisablePinchZoomSafari = function(e) {
            return e.preventDefault();
        };
        window.addEventListener("touchstart", handleDisablePinchZoom);
        document.documentElement.addEventListener("touchstart", handleDisablePinchZoom);
        document.addEventListener("gesturestart", handleDisablePinchZoomSafari);
    }, []);
};


/***/ }),

/***/ 8722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useRemoveScrollTop; }
/* harmony export */ });
/* harmony import */ var context_BlogContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var useRemoveScrollTop = function() {
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath;
    var dispatch = (0,context_BlogContext__WEBPACK_IMPORTED_MODULE_0__/* .useBlogContext */ .F)().dispatch;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!asPath.includes("blog")) {
            dispatch({
                type: "change",
                newState: {
                    prevScrollTop: 0
                }
            });
        }
    }, [
        asPath,
        dispatch
    ]);
};


/***/ }),

/***/ 4772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useSetScreenSize; }
/* harmony export */ });
/* unused harmony export setScreenSize */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var setScreenSize = function() {
    var vh = (window.innerHeight > 640 ? window.innerHeight : 640) * 0.01;
    document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
};
var useSetScreenSize = function() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setScreenSize();
        window.addEventListener("resize", setScreenSize);
        window.addEventListener("orientationchange", setScreenSize);
        return function() {
            window.removeEventListener("resize", setScreenSize);
            window.removeEventListener("orientationchange", setScreenSize);
        };
    }, []);
};


/***/ }),

/***/ 4796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6383);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var locale_en__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4614);
/* harmony import */ var locale_ko__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4804);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5505);
/* harmony import */ var components_NewHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1849);
/* harmony import */ var components_Footer_Footer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2587);
/* harmony import */ var components_Global_ProductButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9220);
/* harmony import */ var components_Home_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4561);
/* harmony import */ var hooks_useDisablePinchZoomIn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5305);
/* harmony import */ var hooks_useSetScreenSize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4772);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var components_Global_index__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6402);
/* harmony import */ var components_Common_FloatingController__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1924);
/* harmony import */ var components_Popup_index__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(763);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9059);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(299);
/* harmony import */ var hooks_useRemoveScrollTop__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8722);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 640px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  width: 100vw;\n  width: 100%;\n  position: relative;\n  z-index: 99;\n  ",
        ";\n\n  .io-target {\n    position: absolute;\n    top: 0;\n    height: 72px;\n    width: 100%;\n    z-index: -1;\n    @media screen and (max-width: 1439px) {\n      height: 64px;\n    }\n    @media screen and (max-width: 1239px) {\n      height: 60px;\n    }\n    @media screen and (max-width: 599px) {\n      height: 56px;\n    }\n  }\n  .product-list-container {\n    background: ",
        ";\n    z-index: 1;\n    @media screen and (min-width: 1440px) {\n      padding: 202px 0;\n    }\n    @media screen and (min-width: 1240px) and (max-width: 1439px) {\n      padding: 146px 0;\n    }\n    @media screen and (min-width: 905px) and (max-width: 1239px) {\n      padding: 146px 0;\n    }\n    @media screen and (max-width: 904px) {\n      padding: 96px 0;\n    }\n  }\n  .floating {\n    position: fixed;\n    z-index: 99;\n    bottom: 56px;\n    text-align: right;\n    right: 32px;\n    @media screen and (max-width: 904px) and (min-width: 600px) {\n      bottom: 32px;\n      right: 32px;\n    }\n    @media screen and (max-width: 599px) {\n      bottom: 32px;\n      right: 16px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var option = {
    threshold: 0.15,
    fallbackInView: true
};
var HomePage = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var t = locale === "en" ? locale_en__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : locale_ko__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_18__/* .useInView */ .YD)(option), 3), $fakeHeaderRef = ref[0], isFakeHeaderVisible = ref[1], fakeHeaderEntry = ref[2];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_18__/* .useInView */ .YD)(option), 2), $mainBannerRef = ref1[0], isMainBannerVisible = ref1[1];
    (0,hooks_useDisablePinchZoomIn__WEBPACK_IMPORTED_MODULE_9__/* .useDisablePinchZoom */ .D)();
    (0,hooks_useSetScreenSize__WEBPACK_IMPORTED_MODULE_10__/* .useSetScreenSize */ .K)();
    (0,hooks_useRemoveScrollTop__WEBPACK_IMPORTED_MODULE_16__/* .useRemoveScrollTop */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HomepageContainer, {
        className: "home",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_11___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: t.metaTag.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "title",
                        content: t.metaTag.title
                    }, "title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: t.metaTag.description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "keywords",
                        content: t.metaTag.keywords
                    }, "keywords"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:type",
                        content: t.metaTag.og_type
                    }, "og:type"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:title",
                        content: t.metaTag.og_title
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:description",
                        content: t.metaTag.og_description
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:url",
                        content: t.metaTag.og_url
                    }, "og:url"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:card",
                        content: t.metaTag.twitter_card
                    }, "twitter:card"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:domain",
                        content: t.metaTag.twitter_domain
                    }, "twitter:domain"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://blue-dot.io"
                    }, "twitter:url"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:title",
                        content: t.metaTag.twitter_title
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:description",
                        content: t.metaTag.twitter_description
                    }, "twitter:description")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Global_index__WEBPACK_IMPORTED_MODULE_12__/* .BypassBlock */ .ok, {
                contentSectionId: "#main-content1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_NewHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                isScrolled: !isFakeHeaderVisible && !!(fakeHeaderEntry === null || fakeHeaderEntry === void 0 ? void 0 : fakeHeaderEntry.target)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "io-target",
                ref: $fakeHeaderRef
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "track",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Home_index__WEBPACK_IMPORTED_MODULE_8__/* .MainBanner */ .$2, {
                        $mainBannerRef: $mainBannerRef
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Home_index__WEBPACK_IMPORTED_MODULE_8__/* .CoreTech */ .K0, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                        className: "product-list-container",
                        children: t.productTemplateList.map(function(product, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Home_index__WEBPACK_IMPORTED_MODULE_8__/* .ProductTemplate */ .K2, {
                                buttons: components_Global_ProductButton__WEBPACK_IMPORTED_MODULE_7__/* .Buttons */ .E[i],
                                imgPath: product.imgPath,
                                productName: product.productName,
                                productPhrase: product.productPhrase,
                                productDescription: product.productDescription,
                                productFeatureList: product.productFeatureList,
                                reverseLayout: product.reverseLayout,
                                className: "product-template"
                            }, product.productName);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Popup_index__WEBPACK_IMPORTED_MODULE_14__/* .Contact */ .r8, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Home_index__WEBPACK_IMPORTED_MODULE_8__/* .CareerBanner */ .cl, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Footer_Footer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Common_FloatingController__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                isVisible: isMainBannerVisible
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HomePage);
var HomepageContainer = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "pages__HomepageContainer",
    componentId: "sc-42260276-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.removeScroll;
}, global_styles__WEBPACK_IMPORTED_MODULE_15__/* .GRAYBG */ .lm);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [779,965,572,833,774,888,179], function() { return __webpack_exec__(7314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);